import { render, staticRenderFns } from "./Noti-Error.vue?vue&type=template&id=2b4c17bb&scoped=true"
import script from "./Noti-Error.vue?vue&type=script&lang=js"
export * from "./Noti-Error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4c17bb",
  null
  
)

export default component.exports